import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { RotationPattern, RotationPatternRequest } from '../interfaces/shift/RotationPattern';

export const RotationPatternService = {
    list: async (institutionId: string): Promise<RotationPattern[]> => {
        const r = await axios.get(ENDPOINTS.SHIFT.ROTATION_PATTERNS(institutionId));
        return r.data;
    },
    getById: async (institutionId: string, id: string): Promise<RotationPattern> => {
        const r = await axios.get(ENDPOINTS.SHIFT.ROTATION_PATTERN_BY_ID(institutionId, id));
        return r.data;
    },
    create: async (institutionId: string, body: RotationPatternRequest): Promise<RotationPattern> => {
        const r = await axios.post(ENDPOINTS.SHIFT.ROTATION_PATTERNS(institutionId), body);
        return r.data;
    },
    remove: async (institutionId: string, id: string): Promise<void> => {
        await axios.delete(ENDPOINTS.SHIFT.ROTATION_PATTERN_BY_ID(institutionId, id));
    },
};
